var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcStepActive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.576172,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#36B37E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5762,
    cy: 10,
    r: 2,
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcStepActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic_step_active.c2c039fa73954c4e5b46b6b0fe09eb60.svg";